/**
 * @deprecated: [Priyanshu] displaySettingsReducer is replaced by displaySettingsReducer
 * */
export const ViewerSettings = {
	SHOW_SEEN_AREA_CHANGED: "SHOW_SEEN_AREA_CHANGED",
} 
